import React from "react";
import AnimationRevealPage from "helpers/AnimationRevealPage.js";
import VerticalWithAlternateImageAndText from "components/features/VerticalWithAlternateImageAndText.js";
import SimpleContactUs from "components/forms/SimpleContactUs.js";
import Footer from "components/footers/MiniCenteredFooter.js";
import { useLocation } from "react-router-dom";
const AllList = () => {
  const location = useLocation();
  return (
    <AnimationRevealPage>
      <VerticalWithAlternateImageAndText data={location.state} />
      <SimpleContactUs />
      <Footer />
    </AnimationRevealPage>
  );
};

export default AllList;
